import * as React from "react";
import IDoctorProfile from "../models/IDoctorProfile";
import { ApiManager } from "../api/ApiManager";
import Select from "react-select";
import { ConsentComponent } from "../components/ongoing/ConsentComponent";
import { ConsentModal } from "../components/ongoing/ConsentModal";


interface ISelectDoctorState {
    doctorsList: IDoctorProfile[],
    isLoading: boolean,
    selectedDoctor: IDoctorProfile;
}

interface ISelectDoctorProps {
    setDoctorProfile: any;
}

class SelectDoctor extends React.Component<ISelectDoctorProps, ISelectDoctorState> {
    state: ISelectDoctorState = {
        doctorsList: [],
        isLoading: false,
        selectedDoctor: null
    };

    componentDidMount(): void {
        this.setState({ isLoading: true });
        ApiManager.getAlbusApis().getDoctorProfile({})
            .then((response: any) => response.content)
            .then((doctorProfiles: IDoctorProfile[]) => {
                this.setState({ doctorsList: doctorProfiles.sort((a, b) => a.name > b.name ? 1 : -1), isLoading: false })
            })
            .catch((err: Error) => {
                this.setState({ isLoading: false });
            })
    }

    handleDoctorSelect = (e: any) => {
        const { value } = e;
        this.setState({
            selectedDoctor: value
        })
    };

    gotoDashboard = (): void => {
        const { selectedDoctor, doctorsList } = this.state;
        if (!selectedDoctor) {
            return;
        }
        console.log("Selected Doctor:", selectedDoctor);
        this.props.setDoctorProfile(selectedDoctor);
    };

    render() {
        const { isLoading, doctorsList, selectedDoctor } = this.state;
        let options = doctorsList.map((doctor) => ({ label: doctor.name, value: doctor }));

        return (
            <div style={{
                minHeight: "100vh",
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }}>
                {isLoading ? "Loading..." : (
                    <div>
                        <Select onChange={this.handleDoctorSelect} id="SelectDoctor" options={options} className="admin-doctor-select"
                            value={selectedDoctor ? { label: selectedDoctor.name, value: selectedDoctor } : null}
                        />

                        <div style={{
                            textAlign: "center",
                            marginTop: "10px"
                        }}>
                            <button style={{
                                color: "#fff",
                                backgroundColor: "#1890ff",
                                borderColor: "#1890ff",
                                lineHeight: "32px",
                                boxShadow: "0 2px 0 rgba(0,0,0,0.045)",
                                height: 32,
                                padding: "0 15px",
                                fontSize: 14,
                                borderRadius: 4
                            }} onClick={this.gotoDashboard} id="ButtonSeeDashboard">See Dashboard
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default SelectDoctor;